export default __webpack_public_path__ + "static/media/Telenor Bank Cheque.5b783ea5.jpg";